module.exports = __webpack_public_path__ + "img/bg_country_market.7e4e7885.jpg";